<template>
    <div>
        <div class="content-box mr60">
            <p class="mb20 text-color-error tac font12px" v-if="id">
                <span class="el-icon-warning"></span>
                若标签被使用更改后会全部更改，请谨慎操作
            </p>
            <el-form ref="form" label-width="120px" :model="formItem" :rules="rules" class="form-wrap">
                <el-form-item label="标签名称：" prop="name">
                    <el-input placeholder="最多输入10个字" :maxlength="10" v-model.trim="formItem.name" clearable></el-input>
                </el-form-item>
            </el-form>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button v-if="isAdd" type="primary" @click="submitModal" :loading="submitLoading" class="action-btn ml20">提交</el-button>
            <el-popconfirm
                v-else
                :disabled="submitLoading"
                title="确定要提交吗？"
                confirm-button-text="确定"
                @confirm="submitModal">
                <el-button slot="reference" type="primary" :loading="submitLoading" class="action-btn ml20">提交</el-button>
            </el-popconfirm>
        </p>
    </div>
</template>

<script>
    import { validEmoji, validHtml } from '@/utils/validate'
    import API from '@/api/workOrder/conf.js';
    export default {
        name: "label1Modal",
        props:{
            type:[String,Number],
            id:[String,Number],
            cbs:Object,
            data:Object,
        },
        data(){
            const validContent = (rule, value, callback) => {
                if (validHtml(value) || validEmoji(value)) {
                    callback(new Error('不可包含表情、html、空格'));
                }else if(value.includes(' ')){
                    callback(new Error('不可包含表情、html、空格'));
                }else{
                    callback()
                }
            };
            return {
                submitLoading:false,
                formItem:{
                    name:'',
                },
                rules:{
                    name:[
                        { required: true, message: '请填写标签名称', trigger: 'change' },
                        { validator: validContent, trigger: 'blur' },
                    ],
                },
            }
        },
        computed:{
            isAdd(){
                return !this.id;
            },
        },
        mounted(){
            if(this.id){
                let data = this.data||{};
                this.formItem.name = data.name;
            }
        },
        methods:{
            submitModal(){
                console.log('submitModal');
                this.$refs.form.validate((valid) => {
                    if(valid){
                        let reqData = {
                            name:this.formItem.name,
                        };
                        this.submitLoading = true;
                        let APIType = '';
                        if(this.id){
                            reqData.id = this.id;
                            APIType = this.type=='2'?'updateVideoLabelConfig':'updateImageLabelConfig';
                        }else{
                            APIType = this.type=='2'?'saveVideoLabel1':'saveImageLabel1';
                        }

                        this.submitLoading = true;
                        API[APIType](reqData).then(res=>{
                            this.submitLoading = false;
                            this.$message.success(res.info||'操作成功');
                            this.cbs.onSubmit('update');
                            this.hideModal();
                        },err=>{
                            this.submitLoading = false;

                            if (err.code == '403') {
                                this.$confirm(err.info||'请求异常', '提示', {
                                    confirmButtonText: '刷新',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                });
                                return
                            }
                            this.$message.error(err.info||'操作失败');
                        })
                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            hideModal(){
                this.$emit('close');
            },
        }
    }
</script>

<style scoped>

</style>
